import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { getUserById } from '../services/userApi';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const { user: authUser } = useAuth();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchUserData = useCallback(async () => {
        if (authUser?.sub) {
            setLoading(true);
            setError(null);
            try {
                const userData = await getUserById(authUser.sub);
                setUser(userData);
            } catch (err) {
                console.error("Failed to fetch user data:", err);
                setError(err);
                setUser(null);
            } finally {
                setLoading(false);
            }
        } else {
            setUser(null);
            setLoading(false);
        }
    }, [authUser]);

    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    const value = { 
        user, 
        loading, 
        error, 
        refetchUser: fetchUserData // Expose a refetch function
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};